import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["overflowable", "show", "collapse"];

  connect() {
    new ResizeObserver(() => {
      requestAnimationFrame(() => this.showWhenOverflow());
    }).observe(this.overflowableTarget);

    this.showWhenOverflow();
  }

  showWhenOverflow() {
    this.showTarget.classList.toggle("hidden", !this.hasOverflow);
  }

  expand() {
    const el = this.overflowableTarget;

    el.style.webkitLineClamp = "unset";
    el.style.maxHeight = "none";
    el.style.overflow = "visible";
    this.showTarget.classList.add("hidden");
    if (this.hasCollapseTarget) this.collapseTarget.classList.remove("hidden");
  }

  collapse() {
    const el = this.overflowableTarget;

    el.style.webkitLineClamp = "";
    el.style.maxHeight = "";
    el.style.overflow = "";
    if (this.hasCollapseTarget) this.collapseTarget.classList.add("hidden");
    this.showWhenOverflow();
  }

  get hasOverflow() {
    // Tolerance is necessary because browsers round subpixels inconsistently,
    // especially across different fonts and device pixel ratios. E.g. if both
    // elements are 18.31px, clientHeight will be 18 while scrollHeight is 19.
    // Custom web fonts (e.g. typekit) can widen this gap to 2-3px on mobile.
    // A real overflow adds a full line (~18px), so +3 is safe.
    return this.overflowableTarget.scrollHeight > this.overflowableTarget.clientHeight + 3;
  }
}
